module.exports = __webpack_public_path__ + "static/media/logo_optimhome_2023.70d29a9b.svg";